/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_Import_ButtonInputs */



/**
* | output |
* | --- |
* | "Import Project" |
*
* @param {Project_Import_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const project_import_button = /** @type {((inputs?: Project_Import_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Import_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Importer le projet")
	if (locale === "de") return /** @type {LocalizedString} */ ("Importprojekt")
	if (locale === "it") return /** @type {LocalizedString} */ ("Importa progetto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Импортный проект")
	if (locale === "es") return /** @type {LocalizedString} */ ("Proyecto de importación")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("导入项目")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロジェクトのインポート")
	if (locale === "hi") return /** @type {LocalizedString} */ ("आयात परियोजना")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Projeto de Importação")
	return /** @type {LocalizedString} */ ("Import Project")
});